// apps/web/src/features/dashboards/china-requests/SlaRow.tsx (#1589)
// Compact SLA stats row. FR-8: the overdue and hot counters cover ONLY
// active work in {READY_FOR_WORK, IN_WORK}; PROCESSED is finalised and is
// never presented as overdue. The shared caption + per-stat `title` carry
// that scoping note so a reader cannot misread the snapshot.
import type { ChinaRequestsDashboardSummary } from '@magimp/shared';
import { formatNumber } from '../../../i18n/formatters.js';
import { CARD_GAP, SECTION_CARD, type AppLocale, type DashboardT } from './section.js';

interface SlaRowProps {
  sla: ChinaRequestsDashboardSummary['sla'];
  locale: AppLocale;
  t: DashboardT;
}

export function SlaRow({ sla, locale, t }: SlaRowProps) {
  const activeScopeNote = t('dashboards:chinaRequests.sla.activeScopeNote');
  const stats: { label: string; value: string; title?: string }[] = [
    {
      label: t('dashboards:chinaRequests.sla.overdueNow'),
      value: formatNumber(sla.overdueNow, locale),
      title: activeScopeNote,
    },
    {
      label: t('dashboards:chinaRequests.sla.hotNow'),
      value: formatNumber(sla.hotNow, locale),
      title: activeScopeNote,
    },
    {
      label: t('dashboards:chinaRequests.sla.avgProcessingDays'),
      value: sla.avgProcessingDays !== null ? formatNumber(sla.avgProcessingDays, locale) : '—',
    },
    {
      label: t('dashboards:chinaRequests.sla.reopenCount'),
      value: formatNumber(sla.reopenCount, locale),
    },
  ];

  return (
    <section style={{ ...SECTION_CARD, display: 'flex', flexDirection: 'column', gap: 8 }}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))',
          gap: CARD_GAP,
        }}
      >
        {stats.map((s) => (
          <div key={s.label} title={s.title}>
            <div style={{ fontSize: 12, color: 'var(--fg-2)' }}>{s.label}</div>
            <div style={{ fontSize: 18, fontWeight: 600, marginTop: 2 }}>{s.value}</div>
          </div>
        ))}
      </div>
      <div style={{ fontSize: 11, color: 'var(--fg-3)' }}>{activeScopeNote}</div>
    </section>
  );
}
